import { CameraControls } from "@react-three/drei";
import CameraControlsImpl from "camera-controls";

export default function Controls() {
	return (
		<CameraControls
			makeDefault
			// Do not let camera go below 0
			maxPolarAngle={Math.PI / 2}
			// Do not show back side
			minAzimuthAngle={-Math.PI / 2}
			maxAzimuthAngle={Math.PI / 2}
			// Limit zoom levels
			minZoom={0.5}
			maxZoom={2}
			// Disable pan
			mouseButtons={{
				left: CameraControlsImpl.ACTION.ROTATE,
				right: CameraControlsImpl.ACTION.NONE,
				wheel: CameraControlsImpl.ACTION.ZOOM,
				middle: CameraControlsImpl.ACTION.NONE,
			}}
		/>
	);
}
